/**
 * Join Tool - Joins two geometry elements (e.g. Walls)
 */
import { BaseTool } from './BaseTool';
import { ThreeEvent } from '@react-three/fiber';

export class JoinTool extends BaseTool {
    id = 'JOIN';
    name = 'Join Geometry';
    cursor = 'crosshair';

    private firstElementId: string | null = null;

    onPointerDown(event: ThreeEvent<PointerEvent>): void {
        const id = this.findElementIdAtPoint(event);
        if (!id) return;

        if (!this.firstElementId) {
            this.firstElementId = id;
            console.log('Join: First element selected', id);
        } else {
            console.log(`Join: Joining ${this.firstElementId} with ${id}`);
            // Logic to join elements would go here
            // e.g. this.context.bimStore.joinElements(this.firstElementId, id);

            // Allow multiple joins with same first element? 
            // BIM behavior: Join(A, B). Tool stays active.
            this.firstElementId = null;
            this.deactivate();
            this.context?.appStore.setActiveTool('select');
        }
    }

    onPointerMove(): void { }
    onPointerUp(): void { }
}
